import { createSlice } from '@reduxjs/toolkit';
import { ProvidersListStateType } from 'src/types/providersList';

const initialState: ProvidersListStateType = {
    data: null,
    dataSystem: null,
    dataWaiting: null,
    loading: false,
    loadingWaiting: false,
    error: false,
};
export const providersListSlice = createSlice({
    name: 'providersList',
    initialState,
    reducers: {
        getProvidersListFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getProvidersListFetchSuccess: (state, action) => {
            if(action.payload.system) {
                state.dataSystem = action.payload.response;
            } else {
                state.data = action.payload.response;
            }
            state.loading = false;
        },
        getProvidersListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        getWaitingProvidersListFetch: (state) => {
            state.loadingWaiting = true;
            state.error = false;
        },
        getWaitingProvidersListFetchSuccess: (state, action) => {
            state.dataWaiting = action.payload;
            state.loadingWaiting = false;
        },
        getWaitingProvidersListFetchFailure: (state, action) => {
            state.data = null;
            state.loadingWaiting = false;
            state.error = true;
        },
    },
});

export const {
    getProvidersListFetch,
    getProvidersListFetchSuccess,
    getProvidersListFetchFailure,
    getWaitingProvidersListFetch,
    getWaitingProvidersListFetchSuccess,
    getWaitingProvidersListFetchFailure,
} = providersListSlice.actions;

export default providersListSlice.reducer;
